export default "__VITE_ASSET__Dz_JZ0aH__"